import React from "react";
import {Image} from 'react-bootstrap';

import "./CasePresentaion.css";

import icon_case from "../../asset/images/icon_case.webp";
import logo_food_02 from "../../asset/images/logo_food_02.png";
import logo_wds from "../../asset/images/logo_wds.png";
import logo_yuanyang from "../../asset/images/logo_yuanyang.png";

//案例展示
class CasePresentaion extends React.Component {
  render() {
    return (
      <div className="presentaion">
        <Image src={icon_case} className="icon_case" />
        <div className="presentaion_cards">
          <div className="container">
            <div className="item item-1">
              <div className="presentaion_content">
                <Image src={logo_food_02} className="card_title_logo" />
                <div className="presentaion_card_word">
                  <div className="presentaion_card_title">
                    中粮东海粮油工业（张家港）有限公司
                  </div>
                  <div className="presentaion_card_content">
                    改造后全年节电率约<span className="card_content_number">26</span>% 
                  </div>
                  <div className="presentaion_card_more">
                    了解详情
                  </div>
                </div>
              </div>
            </div>
            <div className="item item-2">
              <div className="presentaion_content">
                <Image src={logo_food_02} className="card_title_logo" />
                <div className="presentaion_card_word">
                  <div className="presentaion_card_title">
                    中粮黄海粮油工业（山东）有限公司
                  </div>
                  <div className="presentaion_card_content">
                    改造后全年节电率约<span className="card_content_number">30</span>% 
                  </div>
                  <div className="presentaion_card_more">
                    了解详情
                  </div>
                </div>
              </div>
            </div>
            <div className="item item-3">
              <div className="presentaion_content">
                <Image src={logo_food_02} className="card_title_logo" />
                <div className="presentaion_card_word">
                  <div className="presentaion_card_title">
                    中粮佳悦(天津)有限公司 
                  </div>
                  <div className="presentaion_card_content">
                    改造后全年节电率约<span className="card_content_number">36</span>% 
                  </div>
                  <div className="presentaion_card_more">
                    了解详情
                  </div>
                </div>
              </div>
            </div>
            <div className="item item-4">
              <div className="presentaion_content">
                <Image src={logo_wds} className="card_title_logo" />
                <div className="presentaion_card_word">
                  <div className="presentaion_card_title">
                    扬州中远海运重工有限公司 
                  </div>
                  <div className="presentaion_card_content">
                    改造后全年节电率约<span className="card_content_number">30</span>% 
                  </div>
                  <div className="presentaion_card_more">
                    了解详情
                  </div>
                </div>
              </div>
            </div>
            <div className="item item-5">
              <div className="presentaion_content">
                <Image src={logo_yuanyang} className="card_title_logo" />
                <div className="presentaion_card_word">
                  <div className="presentaion_card_title">
                    黑龙江完达山阳光乳业有限公司 
                  </div>
                  <div className="presentaion_card_content">
                    改造后全年节电率约<span className="card_content_number">26</span>% 
                  </div>
                  <div className="presentaion_card_more">
                    了解详情
                  </div>
                </div>
              </div>
            </div>
            <div className="item item-6">
              <div className="presentaion_content">
                <Image src={logo_yuanyang} className="card_title_logo" />
                <div className="presentaion_card_word">
                  <div className="presentaion_card_title">
                    黑龙江完达山哈尔滨乳品有限公司  
                  </div>
                  <div className="presentaion_card_content">
                    改造后全年节电率约<span className="card_content_number">35</span>% 
                  </div>
                  <div className="presentaion_card_more">
                    了解详情
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    )
  }
}

export default CasePresentaion
